import { useEffect } from "react";
import { Box, Container, CssBaseline, Grid } from "@mui/material";
import { Navigate, Outlet, useMatch } from "react-router-dom";
import { appPrefix, appDefaultRoute } from "pages/app-taxi-ranking";
import { useSelector } from "react-redux";
import { LoadingWrapper } from "components/wrappers/LoadingWrapper";
import { Applications } from "configs";
import { useAppDispatch } from "store";
import { setRootPath } from "reducers/auth.reducer";
import { useShouldRenderPageGuard } from "hooks/useShouldRenderPageGuard";
import LoadingLayout from "layouts/common/loader/LoadingLayout.tsx";
import SidebarTaxiRank from "./drawer/SidebarTaxiRank";
import NavbarTaxiRank from "./header/NavbarTaxiRank";

const { AppIdTaxiRanking } = Applications;

export default function Layout() {
    const match = useMatch(appPrefix);
    const { locationsTree } = useSelector((state) => state.newLocation);
    const { shouldRender } = useShouldRenderPageGuard(AppIdTaxiRanking);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setRootPath("/taxi-ranking/home"));
    }, []);

    if (match) {
        return <Navigate to={appDefaultRoute} replace />;
    }

    return shouldRender ? (
        <Container maxWidth="xl" disableGutters>
            <CssBaseline />
            <NavbarTaxiRank />
            <Grid className="custom-container">
                <SidebarTaxiRank rootPath="/taxi-ranking/home" />

                <div className="content">
                    {locationsTree.length > 0 ? (
                        <Outlet />
                    ) : (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
                            <LoadingWrapper isLoading />
                        </Box>
                    )}
                </div>
            </Grid>
        </Container>
    ) : (
        <LoadingLayout />
    );
}

Layout.propTypes = {};
